"use strict";

angular.module("app.elements.footer", [])
  .directive("viFooter", ["$state", function ($state) {
    return {
      restrict: "E",
      scope: {
        showFooter: "="
      },
      controller: function () {
        this.currentYear = new Date().getFullYear();

        // Re-opens the cookie banner so a visitor can change or withdraw an
        // earlier choice. consent.js owns the banner; this only asks for it.
        this.openCookieSettings = function (event) {
          if (event) {
            event.preventDefault();
          }

          if (window.viteezyConsent) {
            window.viteezyConsent.openSettings();
          }
        };

        this.$onInit = function () {
          let dot = window.location.hostname.lastIndexOf('.');
          if (dot > 0) {
            this.country = window.location.hostname.substring(dot + 1).toUpperCase();
          } else {
            this.country = "NL";
          }
        }
      },
      controllerAs: "vm",
      bindToController: true,
      templateUrl: "app/js/modules/elements/footer/footer.html"
    };
  }]);
